import { createSlice } from '@reduxjs/toolkit';

import { ErrorResponse } from 'types/api';
import { DictionaryPayload, DictionaryState } from 'types/dictionaries';

import { RequestStatus } from 'constants/enums';

import { fetchDictionariesBatch, fetchDictionary } from './dictionariesThunks';

const initialState: DictionaryState = {
  data: {},
  countryWithCurrency: [],
  status: RequestStatus.Idle,
  error: null
};

const applyDictionaryPayload = (
  state: DictionaryState,
  payload: DictionaryPayload
) => {
  if (payload.storage === 'countryWithCurrency') {
    state.countryWithCurrency = payload.data;
    return;
  }

  state.data[payload.dict] = payload.data;
};

const dictionariesSlice = createSlice({
  name: 'dictionaries',
  initialState,
  reducers: {
    setDictionariesStatus: (state, action) => {
      state.status = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDictionary.fulfilled, (state, action) => {
        applyDictionaryPayload(state, action.payload);
      })
      .addCase(fetchDictionary.rejected, (state, action) => {
        state.error = action.payload as ErrorResponse;
      })
      .addCase(fetchDictionariesBatch.fulfilled, (state, action) => {
        action.payload.forEach((item) => applyDictionaryPayload(state, item));
      })
      .addCase(fetchDictionariesBatch.rejected, (state, action) => {
        state.error = action.payload as ErrorResponse;
      });
  }
});

export default dictionariesSlice.reducer;
export const { setDictionariesStatus } = dictionariesSlice.actions;
